// src/app/slices/udaSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { deleteAccessory } from './actions';
import { IUda, IUdaParams, AccessoryState } from '../models';

const initialState: AccessoryState<IUda, IUdaParams> = {
  accessories: {},
  params: null,
};

const udaSlice = createSlice({
  name: 'uda',
  initialState,
  reducers: {
    setUda: (state, action: PayloadAction<IUda>) => {
      if (!state.accessories[action.payload.section_id])
        state.accessories[action.payload.section_id] = {};
      state.accessories[action.payload.section_id][action.payload.id] =
        action.payload;
    },
    setUdaParams: (state, action: PayloadAction<IUdaParams>) => {
      state.params = action.payload;
    },
    deleteUda: deleteAccessory,
  },
});

export const { setUda, setUdaParams, deleteUda} = udaSlice.actions;

export default udaSlice.reducer;
